import React from 'react';
import { X } from 'lucide-react';
export function PainPoints() {
  const scrollToPricing = () => {
    document.getElementById('pricing-section')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const points = [{
    title: 'El domingo a las 23:00 estás juntando apuntes',
    desc: 'de 5 compañeros distintos que no coinciden entre sí, y mañana tenés parcial de Anatomía.'
  }, {
    title: 'Llegás a la cursada de Semiología',
    desc: 'y no sabés cómo arrancar la historia clínica frente al paciente. Y eso se nota.'
  }, {
    title: 'Estudiás horas y horas',
    desc: 'pero en el examen se te va todo porque nunca tuviste el contenido ordenado de forma que tenga sentido.'
  }, {
    title: 'Buscás información de Farmacología',
    desc: 'en 10 lugares diferentes y cada fuente te da un dato distinto. No sabés cuál usar.'
  }, {
    title: 'Tus resúmenes los armás desde cero cada vez',
    desc: 'sin un modelo claro, sin saber si estás estudiando lo que el docente realmente toma.'
  }, {
    title: 'Estás en los años clínicos',
    desc: 'y todavía no tenés claro cómo se conectan todas las materias entre sí. La carrera se siente como piezas sueltas.'
  }];
  return <section className="w-full bg-white py-12 md:py-20 px-4" data-id="element-369">
      <div className="max-w-5xl mx-auto" data-id="element-370">
        <div className="text-center mb-12" data-id="element-371">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-3" data-id="element-372">
            ¿Te sentís identificado?
          </h2>
          <p className="text-xl text-brand-blue font-medium mb-2" data-id="element-373">
            Esto le pasa al 90% de los estudiantes de Medicina
          </p>
          <p className="text-slate-500" data-id="element-374">
            No es falta de inteligencia. Es falta de un sistema de estudio real.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12" data-id="element-375">
          {points.map((point, idx) => <div key={idx} className="bg-white rounded-xl p-6 shadow-sm border border-slate-100 border-l-4 border-l-red-500 flex gap-4 items-start" data-id="element-376">
              <div className="bg-red-100 p-1.5 rounded-full shrink-0 mt-1" data-id="element-377">
                <X className="w-5 h-5 text-red-600" strokeWidth={3} data-id="element-378" />
              </div>
              <div data-id="element-379">
                <span className="font-bold text-slate-900" data-id="element-380">{point.title}</span>{' '}
                <span className="text-slate-600" data-id="element-381">{point.desc}</span>
              </div>
            </div>)}
        </div>

        <div className="text-center" data-id="element-382">
          <h3 className="text-2xl md:text-3xl font-bold text-brand-amber mb-8" data-id="element-383">
            ¿Cuántos parciales más vas a improvisar?
          </h3>

          <button onClick={scrollToPricing} className="w-full md:w-auto bg-brand-amber hover:bg-amber-600 text-white text-lg font-bold py-4 px-8 rounded-xl shadow-lg transition-transform hover:scale-105 active:scale-95 min-h-[56px]" data-id="element-384">
            → QUIERO DEJAR DE IMPROVISAR
          </button>
        </div>
      </div>
    </section>;
}